import { jeepRallyApi } from "../api";

const baseUrl = "/api/v1/rally";

export const getAllRallies = async () => {
  return jeepRallyApi.get(baseUrl);
};

export const getRallyById = async (id) => {
  return jeepRallyApi.get(`${baseUrl}/${id}`);
};

export const createRally = async (rally) => {
  return jeepRallyApi.post(baseUrl, rally);
};

export const updateRally = async (id, rally) => {
  return jeepRallyApi.put(`${baseUrl}/${id}`, rally);
};

export const deleteRally = async (id) => {
  return jeepRallyApi.delete(`${baseUrl}/${id}`);
};

export const createRallyPricing = (eventId, payload) => {
  return jeepRallyApi.post(`${baseUrl}/${eventId}/pricing`, payload);
};

export const createRallyPricings = (eventId, prices = []) => {
  return Promise.all(
    prices.map((payload) => createRallyPricing(eventId, payload))
  );
};
